module.exports = __webpack_public_path__ + "img/logo_2026.5cf73498.svg";